export const getLifeEventDataIndex = (
  coverFlowIndex: number,
  todayPage: number
) => (coverFlowIndex > todayPage ? coverFlowIndex - 1 : coverFlowIndex);

export const getLifeEventCoverflowIndex = (
  dataIndex: number,
  todayPage: number
) => (dataIndex > todayPage ? dataIndex + 1 : dataIndex);
